import { put, apply, select, call, takeEvery, all } from 'redux-saga/effects'
import { createAction, createReducer } from 'redux-act'
import { get } from 'lodash'

import { selector as configSelector } from '~/config'

import API from '~/api'

import { Entity, handleError } from '~/utils/entity-utils'

// ACTIONS
export const actions = {
  fetch: {
    request: createAction('fetch order overview', (shop, params) => ({shop, params})),
    failure: createAction('fetch order overview failure', (message, response) => ({message, response})),
    success: createAction('fetch order overview success', (shop, overview, response) => ({shop, overview, response})),
  }
};

// WORKERS
export const workers = {
  * fetchWorker(action, throwError = false) {
    const {shop, params} = get(action, 'payload', {});
    try {

      const config = yield select(configSelector);
      const api = new API(config);
      let requestParams = {
        ...params,
        shop
      };
      const response = yield apply(api, api.callRoute, ['orders/overview/', 'GET', null, requestParams]);

      yield put(actions.fetch.success(shop, response.data, response));

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.fetch);
      if(throwError) {
        throw e;
      }else {
        return e;
      }
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    takeEvery(actions.fetch.request().type, workers.fetchWorker)
  ]);
}

export const reducer = createReducer({
  [actions.fetch.success]: (state, payload) => {
    if(payload['overview'] && payload['shop']) {
      const { overview, shop } = payload;
      let newState = Object.assign({}, state);
      newState[shop] = overview;
      return newState
    }
    return state;
  },
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}